module.exports = __webpack_public_path__ + "gallery-v2.img.empty-icons.white.cc4f88d71cd65b5f44541ed00682c2c1.svg";